'use client';

import { c as _c } from "react/compiler-runtime";
import type { AnchorHTMLAttributes, ReactNode } from 'react';
import { Link } from '@/i18n/navigation';
import { cn } from '@/lib/ui/utils';
import { Panel, PanelContent } from './panel';
export interface DataListItemMetric {
  key: string;
  label: ReactNode;
  value: ReactNode;
}
interface DataListItemProps {
  href: string | undefined;
  image: ReactNode;
  imageBadge?: ReactNode;
  primaryText: ReactNode;
  secondaryText?: ReactNode;
  metrics: readonly DataListItemMetric[];
  compactMetric?: DataListItemMetric;
  mobileMetricsBelowText?: boolean;
  action?: ReactNode;
  showActionOnMobile?: boolean;
  ariaLabel: string;
  onClick?: AnchorHTMLAttributes<HTMLAnchorElement>['onClick'];
  intent?: Pick<AnchorHTMLAttributes<HTMLAnchorElement>, 'onMouseEnter' | 'onFocus' | 'onPointerDown'>;
  testId?: string;
}
export function DataListItem(t0) {
  const $ = _c(64);
  const {
    href,
    image,
    imageBadge,
    primaryText,
    secondaryText,
    metrics,
    compactMetric,
    mobileMetricsBelowText: t1,
    action,
    showActionOnMobile: t2,
    ariaLabel,
    onClick,
    intent,
    testId
  } = t0;
  const mobileMetricsBelowText = t1 === undefined ? false : t1;
  const showActionOnMobile = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== ariaLabel || $[1] !== href || $[2] !== intent || $[3] !== onClick) {
    t3 = href === undefined ? null : <Link href={href} prefetch={false} aria-label={ariaLabel} onClick={onClick} {...intent} className="absolute inset-0 z-0 rounded-card focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-border-primary" />;
    $[0] = ariaLabel;
    $[1] = href;
    $[2] = intent;
    $[3] = onClick;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = compactMetric === undefined ? "@3xl:flex @3xl:items-center @3xl:gap-6" : "lg:flex lg:items-center lg:gap-6";
  const t5 = action === undefined && compactMetric === undefined ? "grid-cols-1" : compactMetric !== undefined || showActionOnMobile ? "grid-cols-[minmax(0,1fr)_auto]" : "grid-cols-1 lg:grid-cols-[minmax(0,1fr)_auto]";
  const t6 = mobileMetricsBelowText && (showActionOnMobile ? "max-lg:grid-cols-[3rem_minmax(0,1fr)_auto] max-lg:gap-x-3 max-lg:gap-y-2" : "max-lg:grid-cols-[3rem_minmax(0,1fr)] max-lg:gap-x-3 max-lg:gap-y-2");
  let t7;
  if ($[5] !== t4 || $[6] !== t5 || $[7] !== t6) {
    t7 = cn("grid min-w-0 gap-3", t4, t5, t6);
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = mobileMetricsBelowText && "max-lg:contents";
  let t9;
  if ($[9] !== t8) {
    t9 = cn("pointer-events-none relative flex min-w-0 flex-1 items-center gap-3", t8);
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = mobileMetricsBelowText && "max-lg:col-start-1 max-lg:row-start-1";
  let t11;
  if ($[11] !== t10) {
    t11 = cn("relative inline-flex shrink-0", t10);
    $[11] = t10;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== imageBadge) {
    t12 = imageBadge === undefined ? null : <span aria-hidden="true" className="absolute -bottom-1 -right-1 grid size-5 place-items-center rounded-full bg-background-primary">{imageBadge}</span>;
    $[13] = imageBadge;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== image || $[16] !== t11 || $[17] !== t12) {
    t13 = <span className={t11}>{image}{t12}</span>;
    $[15] = image;
    $[16] = t11;
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  const t14 = mobileMetricsBelowText && "flex-1 max-lg:col-start-2 max-lg:row-start-1 max-lg:self-center";
  let t15;
  if ($[19] !== t14) {
    t15 = cn("flex min-w-0 flex-col gap-1", t14);
    $[19] = t14;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== primaryText) {
    t16 = <span className="truncate text-body font-medium text-foreground-primary">{primaryText}</span>;
    $[21] = primaryText;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== secondaryText) {
    t17 = secondaryText === undefined ? null : <span className="line-clamp-2 text-caption text-foreground-tertiary">{secondaryText}</span>;
    $[23] = secondaryText;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== t15 || $[26] !== t16 || $[27] !== t17) {
    t18 = <div className={t15}>{t16}{t17}</div>;
    $[25] = t15;
    $[26] = t16;
    $[27] = t17;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== t13 || $[30] !== t18 || $[31] !== t9) {
    t19 = <div className={t9}>{t13}{t18}</div>;
    $[29] = t13;
    $[30] = t18;
    $[31] = t9;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== compactMetric || $[34] !== mobileMetricsBelowText || $[35] !== showActionOnMobile) {
    t20 = cn("pointer-events-none relative col-span-full grid grid-cols-2 gap-x-6 gap-y-2", mobileMetricsBelowText ? cn("max-lg:col-start-2 max-lg:row-start-2 max-lg:grid-cols-3 max-lg:gap-1 lg:flex lg:shrink-0 lg:gap-6", showActionOnMobile ? "max-lg:col-span-2" : "max-lg:col-span-1") : compactMetric === undefined ? "@3xl:flex @3xl:shrink-0 @3xl:gap-6" : "max-lg:hidden lg:flex lg:shrink-0 lg:gap-6");
    $[33] = compactMetric;
    $[34] = mobileMetricsBelowText;
    $[35] = showActionOnMobile;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== metrics || $[38] !== mobileMetricsBelowText) {
    let t22;
    if ($[40] !== mobileMetricsBelowText) {
      t22 = (metric, index) => <div key={metric.key} className={cn("flex min-w-0 flex-col gap-1 @3xl:items-end", mobileMetricsBelowText && index >= 3 && "max-lg:hidden")}><dt className={cn("text-caption text-foreground-tertiary", mobileMetricsBelowText && "max-lg:truncate")}>{metric.label}</dt><dd className={cn("text-body font-medium tabular-nums text-foreground-primary", mobileMetricsBelowText && "max-lg:truncate max-lg:text-caption max-lg:tracking-tight")}>{metric.value}</dd></div>;
      $[40] = mobileMetricsBelowText;
      $[41] = t22;
    } else {
      t22 = $[41];
    }
    t21 = metrics.map(t22);
    $[37] = metrics;
    $[38] = mobileMetricsBelowText;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[42] !== t20 || $[43] !== t21) {
    t22 = <dl className={t20}>{t21}</dl>;
    $[42] = t20;
    $[43] = t21;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] !== compactMetric) {
    t23 = compactMetric === undefined ? null : <dl className="pointer-events-none relative col-start-2 row-start-1 self-center text-right lg:hidden"><div className="flex min-w-0 flex-col gap-1"><dt className="text-caption text-foreground-tertiary">{compactMetric.label}</dt><dd className="text-body font-medium tabular-nums text-foreground-primary">{compactMetric.value}</dd></div></dl>;
    $[45] = compactMetric;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== action || $[48] !== compactMetric || $[49] !== mobileMetricsBelowText || $[50] !== showActionOnMobile) {
    t24 = action === undefined ? null : <div className={cn("relative z-10 shrink-0 self-center", showActionOnMobile ? cn("col-start-2 row-start-1 max-lg:justify-self-end", mobileMetricsBelowText && "max-lg:col-start-3", compactMetric !== undefined && "max-lg:row-start-2") : "col-start-2 row-start-1 max-lg:hidden")}>{action}</div>;
    $[47] = action;
    $[48] = compactMetric;
    $[49] = mobileMetricsBelowText;
    $[50] = showActionOnMobile;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] !== t19 || $[53] !== t22 || $[54] !== t23 || $[55] !== t24 || $[56] !== t7) {
    t25 = <div className={t7}>{t19}{t22}{t23}{t24}</div>;
    $[52] = t19;
    $[53] = t22;
    $[54] = t23;
    $[55] = t24;
    $[56] = t7;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  let t26;
  if ($[58] !== t25 || $[59] !== t3) {
    t26 = <PanelContent className="flex flex-col gap-3 p-0 lg:p-3">{t3}{t25}</PanelContent>;
    $[58] = t25;
    $[59] = t3;
    $[60] = t26;
  } else {
    t26 = $[60];
  }
  let t27;
  if ($[61] !== t26 || $[62] !== testId) {
    t27 = <Panel density="flush" surface="none" inheritBackground={true} className="@container relative transition-colors duration-fast lg:hover:bg-background-tertiary/50" data-testid={testId}>{t26}</Panel>;
    $[61] = t26;
    $[62] = testId;
    $[63] = t27;
  } else {
    t27 = $[63];
  }
  return t27;
}